import {connect} from 'react-redux'
import {toJS} from '../../../util/ToJS'
import GrandmasterExplanations from '../components/GrandmasterExplanations'
import {chooseActiveExplanationGm, selectActiveExplanation, viewExplanations} from '../../../redux/modules/grandmaster'
import {wrapDispatch} from 'multireducer'
import {postToggleVote} from '../../../redux/modules/content'
import {showModal} from '../../../redux/modules/modal'

const mapStateToProps = state => (selectActiveExplanation(state))

const mapDispatchToProps = dispatch => {
  return {
    chooseActiveExplanation: explanationId => {
      dispatch(chooseActiveExplanationGm(explanationId))
    },
    exitExplanations: () => {
      dispatch(viewExplanations(false))
    },
    toggleVote: (type,id) => wrapDispatch(dispatch, 'grandmasterExplanation')(postToggleVote(type,id)),
    report: (item) => {
      dispatch(showModal('REPORT',{
        item: item,
      }))
    },
    openShare: (slug, type) => {
      dispatch(showModal('SHARE',{
        type: type,
        slug: `${window.location.origin}${slug}`
      }))
    }
  }
}

const VisibleGrandmasterExplanations = connect(
  mapStateToProps,
  mapDispatchToProps
)(toJS(GrandmasterExplanations))

export default VisibleGrandmasterExplanations



// WEBPACK FOOTER //
// ./src/domains/grandmaster/containers/VisibleGrandmasterExplanations.js